import { ButtonMob, instance, NuevaAxiosURL, perlo } from "../../utils/utils";
import React, { useRef } from "react";
import "../inicio/inicio.css";
import { useNavigate,useParams  } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import { ModalConoceme } from "../Modal/ModalConoceme";
import { Allvideos } from "../grupales/utils";
import "./TutorialReserva.css";
import Joyride, { ACTIONS, EVENTS, STATUS } from "react-joyride";
import { Categorias, Paso2,Paso1, Paso5, Paso6, Paso7, Paso3 } from "./stepsHelp";
import Moment from "moment";
import { extendMoment } from "moment-range";
const TutorialReserva = (props) => {
  const elevvaT = props.elevvaT;
  const pathHere = props.path;
  const zonahorairachange =props.zonahorairachange
  const navigate = useNavigate();
  const { id } = useParams();
  const steps = [
    {
      target: "#Barralis3",
      placement: "right",
      content: (
        <div  style={{ color: "#394F65", fontWeight: "400",padding:'2%' }}>
        Recuerda que puedes ingresar a reserva de clases por el panel de control o nuestro menú lateral.
        </div>
      ),
      spotlightPadding: 0,
      disableBeacon: true,
      locale: {
        last: <span aria-label="skip">Finalizar tutorial</span>,
        skip: (
          <span  onClick={()=>navigate(`/training/${id}`)}
            aria-label="skip"
            style={{ textDecoration: "underline", color: "#CB3D82" }}
          >
            Finalizar tutorial
          </span>
        ),
        spotlightClicks: true,
        next: <span aria-label="skip">Siguiente</span>,
        back: <span aria-label="skip">Anterior</span>,
      },
    },
     {
      target: "#categoryReservaTutorial",
      placement: "right",
      content: (
        <div style={{ color: "#394F65", fontWeight: "400" }}>
          Acá podrás seleccionar entre nuestras clases grupales en vivo y disciplinas personalizadas.
        </div>
      ),
      spotlightPadding: 0,
      locale: {
        last: <span aria-label="skip"  onClick={()=>navigate(`/training/${id}`)}>Finalizar tutorial</span>,
        skip: (
          <span   onClick={()=>navigate(`/training/${id}`)}
            aria-label="skip"
            style={{ textDecoration: "underline", color: "#CB3D82" }}
          >
            Finalizar tutorial
          </span>
        ),
        next: <span aria-label="skip">Siguiente</span>,
        back: <span aria-label="skip">Anterior</span>,
      },
    },
    {
      target: "#filtrosTutorial",
      placement: "bottom",
      content: (
        <div style={{ color: "#394F65", fontWeight: "400" }}>
          Acá podrás seleccionar entre nuestras clases grupales en vivo y disciplinas personalizadas.
        </div>
      ),
      spotlightPadding: 0,
      locale: {
        last: <span aria-label="skip" onClick={()=>navigate(`/training/${id}`)}>Finalizar tutorial</span>,
        skip: (
          <span 
            aria-label="skip"
            style={{ textDecoration: "underline", color: "#CB3D82" }}
            onClick={()=>navigate(`/training/${id}`)} >
            Finalizar tutorial
          </span>
        ),
        next: <span aria-label="skip">Siguiente</span>,
        back: <span aria-label="skip">Anterior</span>,
      },
    },
    {
      target: "#totalClasesTutorial",
      placement: "bottom",
      content: (
        <div style={{ color: "#394F65", fontWeight: "400" }}>
          Selecciona tu clase de preferencia
dentro de nuestras opciones disponibles.
        </div>
      ),
      spotlightPadding: 0,
      locale: {
        last: <span aria-label="skip" onClick={()=>navigate(`/training/${id}`)}>Finalizar tutorial</span>,
        skip: (
          <span   onClick={()=>navigate(`/training/${id}`)}
            aria-label="skip"
            style={{ textDecoration: "underline", color: "#CB3D82" }}
          >
            Finalizar tutorial
          </span>
        ),
        next: <span aria-label="skip">Siguiente</span>,
        back: <span aria-label="skip">Anterior</span>,
      },
    },
    {
      target: "#tutorialButtonReserva",
      placement: "bottom",
      content: (
        <div style={{ color: "#394F65", fontWeight: "400" }}>
          Tras escoger tu clase, a continuación
selecciona una nueva reserva.
        </div>
      ),
      spotlightPadding: 0,
      locale: {
        last: <span aria-label="skip" onClick={()=>navigate(`/training/${id}`)}>Finalizar tutorial</span>,
        skip: (
          <span   onClick={()=>navigate(`/training/${id}`)}
            aria-label="skip"
            style={{ textDecoration: "underline", color: "#CB3D82" }}
          >
            Finalizar tutorial
          </span>
        ),
        next: <span aria-label="skip">Siguiente</span>,
        back: <span aria-label="skip">Anterior</span>,
      },
    },
    {
      target: "#SelectHourTutorial",
      placement: "left",
      content: (
        <div style={{ color: "#394F65", fontWeight: "400" }}>
         Selecciona dentro de nuestros horarios
la opción que más se acomode a tus necesidades
y da click a reserva.
        </div>
      ),
      spotlightPadding: 0,
      locale: {
        last: <span aria-label="skip" onClick={()=>navigate(`/training/${id}`)}>Finalizar tutorial</span>,
        skip: (
          <span  onClick={()=>navigate(`/training/${id}`)}
            aria-label="skip"
            style={{ textDecoration: "underline", color: "#CB3D82" }}
          >
            Finalizar tutorial
          </span>
        ),
        next: <span aria-label="skip">Siguiente</span>,
        back: <span aria-label="skip">Anterior</span>,
      },
    },
    {
      target: "#Selectclickreserva",
      placement: "left",
      content: (
        <div style={{ color: "#394F65", fontWeight: "400" }}>
         Recuerda que debes disponer de créditos o un plan activo para reservar. 
Si estas conforme, da click a reservar.
        </div>
      ),
      spotlightPadding: 0,
      locale: {
        last: <span aria-label="skip" onClick={()=>navigate(`/training/${id}`)}>Finalizar tutorial</span>,
        skip: (
          <span  onClick={()=>navigate(`/training/${id}`)}
            aria-label="skip"
            style={{ textDecoration: "underline", color: "#CB3D82" }}
          >
            Finalizar tutorial
          </span>
        ),
        next: <span aria-label="skip">Siguiente</span>,
        back: <span aria-label="skip">Anterior</span>,
      },
    },
    {
      target: "#ReservadoTutotial",
      placement: "left",
      content: (
        <div style={{ color: "#394F65", fontWeight: "400" }}>
         ¡Listo! has asignado tus clases para tomarlas después; accede a ellas en tu panel principal en la sección de tu próxima clase.
        </div>
      ),
      spotlightPadding: 0,
      locale: {
        last: <span aria-label="skip" onClick={()=>navigate(`/training/${id}`)}>Finalizar tutorial</span>,
        skip: (
          <span   onClick={()=>navigate(`/training/${id}`)}
            aria-label="skip"
            style={{ textDecoration: "underline", color: "#CB3D82" }}
          >
            Finalizar tutorial
          </span>
        ),
        next: <span aria-label="skip">Siguiente</span>,
        back: <span aria-label="skip">Anterior</span>,
      },
    },
    {
      target: "#categoryReservaTutorial",
      placement: "right",
      content: (
        <div style={{ color: "#394F65", fontWeight: "400" }}>
         Para reservas nuestras disciplinas personalizadas solo debes seleccionar tu categoría según el nivel que prefieras.
        </div>
      ),
      spotlightPadding: 0,
      locale: {
        last: <span aria-label="skip"  onClick={()=>navigate(`/training/${id}`)}>Finalizar tutorial</span>,
        skip: (
          <span   onClick={()=>navigate(`/training/${id}`)}
            aria-label="skip"
            style={{ textDecoration: "underline", color: "#CB3D82" }}
          >
            Finalizar tutorial
          </span>
        ),
        next: <span aria-label="skip">Siguiente</span>,
        back: <span aria-label="skip">Anterior</span>,
      },
    },
    {
      target: "#totalClasesTutorial",
      placement: "bottom",
      content: (
        <div style={{ color: "#394F65", fontWeight: "400" }}>
          Selecciona tu clase de preferencia
dentro de nuestras opciones disponibles.
        </div>
      ),
      spotlightPadding: 0,
      locale: {
        last: <span aria-label="skip" onClick={()=>navigate(`/training/${id}`)}>Finalizar tutorial</span>,
        skip: (
          <span   onClick={()=>navigate(`/training/${id}`)}
            aria-label="skip"
            style={{ textDecoration: "underline", color: "#CB3D82" }}
          >
            Finalizar tutorial
          </span>
        ),
        next: <span aria-label="skip">Siguiente</span>,
        back: <span aria-label="skip">Anterior</span>,
      },
    },
    {
      target: "#tutorialButtonReserva",
      placement: "bottom",
      content: (
        <div style={{ color: "#394F65", fontWeight: "400" }}>
          Tras escoger tu clase, a continuación
selecciona una nueva reserva.
        </div>
      ),
      spotlightPadding: 0,
      locale: {
        last: <span aria-label="skip" onClick={()=>navigate(`/training/${id}`)}>Finalizar tutorial</span>,
        skip: (
          <span   onClick={()=>navigate(`/training/${id}`)}
            aria-label="skip"
            style={{ textDecoration: "underline", color: "#CB3D82" }}
          >
            Finalizar tutorial
          </span>
        ),
        next: <span aria-label="skip">Siguiente</span>,
        back: <span aria-label="skip">Anterior</span>,
      },
    },
    {
      target: "#tutorialTeacher",
      placement: "left",
      content: (
        <div style={{ color: "#394F65", fontWeight: "400" }}>
        Puedes seleccionar al profesor
 que deseas dicte tu clase, además de conocer
un poco más sobre él. Recuerda que según tu plan, la reserva podrá tener un costo adicional y restricciones de tiempo de 24 horas.
        </div>
      ),
      spotlightPadding: 0,
      locale: {
        last: <span aria-label="skip" onClick={()=>navigate(`/training/${id}`)}>Finalizar tutorial</span>,
        skip: (
          <span  onClick={()=>navigate(`/training/${id}`)}
            aria-label="skip"
            style={{ textDecoration: "underline", color: "#CB3D82" }}
          >
            Finalizar tutorial
          </span>
        ),
        next: <span aria-label="skip">Siguiente</span>,
        back: <span aria-label="skip">Anterior</span>,
      },
    },
    {
      target: "#bookingBook",
      placement: "left",
      content: (
        <div style={{ color: "#394F65", fontWeight: "400" }}>
      Después, podrás seleccionar fechas de tus entrenamientos. Recuerda que según tu plan, reservar tu clase con menos tiempo de antelación podrá tener un costo adicional y restricciones de tiempo.
        </div>
      ),
      spotlightPadding: 0,
      locale: {
        last: <span aria-label="skip" onClick={()=>navigate(`/training/${id}`)}>Finalizar tutorial</span>,
        skip: (
          <span  onClick={()=>navigate(`/training/${id}`)}
            aria-label="skip"
            style={{ textDecoration: "underline", color: "#CB3D82" }}
          >
            Finalizar tutorial
          </span>
        ),
        next: <span aria-label="skip">Siguiente</span>,
        back: <span aria-label="skip">Anterior</span>,
      },
    },
    {
      target: "#Selectclickreserva",
      placement: "left",
      content: (
        <div style={{ color: "#394F65", fontWeight: "400" }}>
         Recuerda que debes disponer de créditos o un plan activo para reservar. 
Si estas conforme, da click a reserva.
        </div>
      ),
      spotlightPadding: 0,
      locale: {
        last: <span aria-label="skip" onClick={()=>navigate(`/training/${id}`)}>Finalizar tutorial</span>,
        skip: (
          <span  onClick={()=>navigate(`/training/${id}`)}
            aria-label="skip"
            style={{ textDecoration: "underline", color: "#CB3D82" }}
          >
            Finalizar tutorial
          </span>
        ),
        next: <span aria-label="skip">Siguiente</span>,
        back: <span aria-label="skip">Anterior</span>,
      },
    },
    {
      target: "#ReservadoTutotial",
      placement: "left",
      content: (
        <div style={{ color: "#394F65", fontWeight: "400" }}>
         ¡Listo! has asignado tus clases para tomarlas después; accede a ellas en tu panel principal en la sección de tu próxima clase.
        </div>
      ),
      spotlightPadding: 0,
      locale: {
        last: <span aria-label="skip" onClick={()=>navigate(`/training/${id}`)}>Finalizar tutorial</span>,
        skip: (
          <span   onClick={()=>navigate(`/training/${id}`)}
            aria-label="skip"
            style={{ textDecoration: "underline", color: "#CB3D82" }}
          >
            Finalizar tutorial
          </span>
        ),
        next: <span aria-label="skip">Siguiente</span>,
        back: <span aria-label="skip">Anterior</span>,
      },
    },
  
  ];
  const [pasos, setpasos] = useState(steps);
  const [stepIndex, setstepIndex] = useState(0);
  const [stepIndexFast, setstepIndexFast] = useState(0);
  const [correr, setcorrer] = useState(false);
  const [heightjoyride, setheightjoyride] = useState(false);
  const [counter, setcounter] = useState(0);

  const [trainings, setTrainings] = useState([]);
  const [tomorrow, setTomorrow] = useState('');


  useEffect(() => {
    if (stepIndex > 1) {
      setheightjoyride(false);
    }
  }, [stepIndex]);

  useEffect(() => {
    instance
      .get(`${NuevaAxiosURL}trainings`)
      .then((response) => {
        setTrainings(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
      setcorrer(!correr)

      const today = new Date();
      const tomorrowDate = new Date(today);
      tomorrowDate.setDate(tomorrowDate.getDate() + 1);
  
      const monthNames = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
      const month = monthNames[tomorrowDate.getMonth()];
      const day = tomorrowDate.getDate();
  
      setTomorrow(`${month} ${day}`);
  }, []);
  const handleJoyrideCallback = (data) => {
    const { status, type, action, index } = data;

    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
     let timeDelay= index == 4 && action === ACTIONS.PREV?500:0
      setstepIndexFast(  index + (action === ACTIONS.PREV ? -1 : 1))
      // Update state to advance the tour
      setTimeout(() => {  

        setstepIndex(index + (action === ACTIONS.PREV ? -1 : 1));
      }, timeDelay);
    } else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      // Need to set our running state to false, so we can restart if we click start again.
      setcorrer(false);
      setstepIndex(0);
    }
  };

  useEffect(() => {
    const rootr = document.documentElement;
    var number = document.getElementById("number");
    var count = 0;
    rootr.style.setProperty(
      "--percentageCircularBar",
      300 - (300 * counter) / 100 + "%"
    );
    setInterval(() => {
      if (count === counter) {
        clearInterval();
      } else {
        count += 1;
        if (number) number.innerHTML = count + "%";
      }
    }, 30);
  }, [counter]);
  useEffect(() => {
    setcounter(50);
  }, []);

  const selectOption = (
    refContainer,
    index,
    classess,
    arr,
    onlyone,
    pathHere
  ) => {
    if (onlyone === true) {
      for (const iterator of arr) {
        iterator[2].current.classList = classess;
        iterator[2].current.active = false;
        iterator[3] = false;
      }
    }

    if (refContainer.current.active === true) {
      refContainer.current.classList = classess;
      refContainer.current.active = false;
    } else {
      refContainer.current.classList = classess + " active";
      refContainer.current.active = true;
    }
    if (pathHere === "out") {
      perlo();
    } else {
      return navigate(pathHere);
    }
  };
  const selectReserva =trainings && trainings.filter((e) => e.id == 9);
  const trainers = selectReserva[0]?.trainers;
 

  const profesores = [
    
    {
      id: 40,
      name: "Sofìa Garcia",
      credito: 2,
      current_rating: "-1.00",
      age: 34,
      clasesTotal: 230,
      perfil:
        "Profesiona en Cultura Física, Deporte y Recreación. Con experiencia en el campo de entremamientio físico para la salud, desde diversas metologìas",
        profile_pic:process.env.PUBLIC_URL + "/img/sofia_pic.png", // img para perfil
         // img para medallas
      
    },
    {
      id: 62,
      name: "Camílo Linares",
      credito: 2,
      current_rating: "2.00",
      age: 34,
      clasesTotal: 230,
      perfil:
        "Profesiona en Cultura Física, Deporte y Recreación. Con experiencia en el campo de entremamientio físico para la salud, desde diversas metologìas",
      profile_pic:process.env.PUBLIC_URL + "/img/alex_pic.png", // img para perfi
       // img para perfil
      
    },
    {
      id: 41,
      name: "Catalina Morales",
      credito: 2,
      current_rating: "4.00",
      age: 34,
      clasesTotal: 230,
      perfil:
        "Profesiona en Cultura Física, Deporte y Recreación. Con experiencia en el campo de entremamientio físico para la salud, desde diversas metologìas",
      profile_pic: process.env.PUBLIC_URL + "/img/sofia_pic.png", // img para perfil
        // img para medallas
      
    },
    {
      id: 39,
      name: "Andres Monico",
      credito: 2,
      current_rating: "-1.00",
      age: 34,
      clasesTotal: 230,
      perfil:
        "Profesiona en Cultura Física, Deporte y Recreación. Con experiencia en el campo de entremamientio físico para la salud, desde diversas metologìas",
      profile_pic:process.env.PUBLIC_URL + "/img/alex_pic.png", // img para perfil
      
    },
    {
      id: 38,
      name: "Jairo Bernal",
      credito: 2,
      current_rating: "5.00",
      age: 34,
      clasesTotal: 230,
      perfil:
        "Profesiona en Cultura Física, Deporte y Recreación. Con experiencia en el campo de entremamientio físico para la salud, desde diversas metologìas",
      profile_pic: process.env.PUBLIC_URL + "/img/sofia_pic.png", // img para perfil
        // img para medallas
     
    },
    {
      id: 80,
      name: "Camílo Linares",
      credito: 2,
      current_rating: "3.00",
      age: 34,
      clasesTotal: 230,
      perfil:
        "Profesiona en Cultura Física, Deporte y Recreación. Con experiencia en el campo de entremamientio físico para la salud, desde diversas metologìas",
      profile_pic:process.env.PUBLIC_URL + "/img/alex_pic.png", // img para perfi
        
    },
    {
      id: 67,
      name: "Mariana Perez",
      credito: 2,
      current_rating: "-1.00",
      age: 34,
      clasesTotal: 230,
      perfil:
        "Profesiona en Cultura Física, Deporte y Recreación. Con experiencia en el campo de entremamientio físico para la salud, desde diversas metologìas",
      profile_pic: process.env.PUBLIC_URL + "/img/sofia_pic.png", // img para perfil
       
    },
  ];
 

  const Paso4 = (props) =>{
    return( <div  className="d-flex col-9"
    style={{
      background: "white",
      height: "100%",
    
      borderRadius: "20px",
      
      justifyContent: "center",
    }}>
    <div
    className="col-6 d-flex"
    style={{ position: "relative", justifyContent: "center",padding:'5%' }}
    >
    
    <img className="w-100"
    style={{padding:'0 4%',backgroundImage:'cover'}}
    src={ 
      process.env.PUBLIC_URL + "/img/mascarareservafinal.png"
       // Aquí se pasa la propiedad cover_picture del objeto
    }
    alt=""
    />
    
    <div style={{ top: "11%", position: "absolute", left: "18%" }} className="w-100">
    <div className="d-flex my-auto ">
     
    </div>
    </div>
    </div><div
    className="col-6 d-flex"
    style={{
    justifyContent: "center",
    flexDirection: "column",
    gap:'1%',
    padding: "5% 5% 5% 0",
    }}
    >
  <div className="d-flex justify-content-center ">
      <div
    
        className=""
        style={{
          background: "transparent",
          border: "1px solid #A8C2D7",
          padding: "1vmin",
      
          height: "fit-content",
          cursor: "pointer",
          color: "#A8C2D7",
          borderRadius: "10px",
        }}
      >
        <span style={{ fontSize: "1rem" }}>
          <i className="bi bi-chevron-left"></i>
        </span>
      </div>
      <div className=" my-auto mx-2 d-flex flex-column justify-content-center  ">
        <span
          className="mt-2"
          style={{ color: "#394F65", fontSize:'calc(0.7rem + 0.3vw)' }}
        >
          Resumen 
        </span>
        <span
          style={{
            color: "#394F65",
            fontWeight: "bold",
            fontSize:'calc(1.3rem + 0.3vw)'
          }}
        >
        de tu reserva
        </span>{" "}
       {" "}
 
      </div>
    </div>
           {" "}
  <div className="d-flex jusctify-content-center flex-column gap-1" >
                {props.trainers.slice(0,2).map((trainer) => (
              <div  id="Selectclickreserva"
                className="d-flex"
                style={{
                  background: "#F4F0ED",
                  justifyContent: "center",
                  flexDirection: "column",
                  borderRadius: "25px",
                  padding: "2%",
             
                  width: "100%",
               
                }}
              >
                <span style={{ textAlign: "center",fontSize: "calc(1rem + 0.3vw)" }}>
                  <i className="bi bi-clock-history"></i>
                </span>

                  <span
                    style={{
                      textAlign: "center",
                      color: "#394F65",
                    
                      fontSize: "calc(0.5rem + 0.3vw)",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {/* <span>Prof. {trainer[0].name}</span> */}

                    {trainer.name}
                  </span>
                  <span
                  style={{
                    textAlign: "center",
                    color: "#D74688",
                  
                    fontSize: "calc(0.5rem + 0.3vw)",
                    whiteSpace: "nowrap",
                  }}
                >
                  Zumba grupal
                </span>
                <span
                  style={{
                    textAlign: "center",
                    color: "#394F65",
                   
                    fontSize: "calc(0.5rem + 0.3vw)",
                    whiteSpace: "nowrap",
                  }}
                >
                  Agosto 17 de 2020 / 9:00 a.m / 10:00 a.m
                </span>
                  </div>
                ))}
              
             
              <hr />
<div   >  
 <div className="d-flex justify-content-center col-12"  >
                <div className="col-6" style={{textAlign:'right',fontSize: "calc(0.5rem + 0.3vw)"}}>2 clases:</div>
                <div  className="col-6" style={{ fontSize: "calc(0.5rem + 0.3vw)"}}>0 creditos</div>
              </div>
              <div className="d-flex justify-content-center col-12">
                <div  className="col-6" style={{textAlign:'right',fontSize: "calc(0.5rem + 0.3vw)"}}>Descuento:</div>
                <div  className="col-6" style={{ fontSize: "calc(0.5rem + 0.3vw)"}}>0 creditos</div>
              </div>
              <div className="d-flex justify-content-center col-12">
                <div  className="col-6" style={{textAlign:'right',fontSize: "calc(0.5rem + 0.3vw)"}}
                >Créditos restantes:</div>
                <div  className="col-6" style={{ fontSize: "calc(0.5rem + 0.3vw)"}}>0 creditos</div>
              </div></div>
           
              <div className="d-flex py-2" style={{ justifyContent: "center" }}>
              <ButtonMob icon={'ms-2 bi bi-calendar3 right'}
  className=""
  text="Reserva"
/>
              </div>
            </div>
    
    </div>
    </div>)
  }

 

 const reservasPaso5 =[["2023-03-27 1:00",1]]
 const moment = extendMoment(Moment);
 const valueDate =moment().format().slice(0,10);
 const dateTest = [valueDate + ' 20:00',1]
 const Barra = [
  [
    "Progreso",
    <i className="bi bi-house"></i>,
    useRef(null),
    useRef(null),
    "/Dashboard",
  ],
  [
    "Mi perfil",
    <i className="bi bi-person-circle"></i>,
    useRef(null),
    useRef(null),
    "#",
  ],
  [
    "Videos de bienestar y entrenamiento",
    <i className="bi bi-play-btn-fill"></i>,
    useRef(null),
    useRef(null),
    "#",
  ],
  [
    "Reserva de clases",
    <i className="bi bi-calendar-date"></i>,
    useRef(null),
    useRef(null),
    "#",
  ],
  [
    "Adquiere equipos",
    <i className="bi bi-box2"></i>,
    useRef(null),
    useRef(null),
    "#",
  ],
  [
    "Preguntas frecuentes",
    <i className="bi bi-chat-right-quote"></i>,
    useRef(null),
    useRef(null),
    "#",
  ],
  [
    "Términos y condiciones políticas de privacidad",
    <i className="bi bi-pencil-square"></i>,
    useRef(null),
    useRef(null),
    "#",
  ],
  [
    "Cerrar sesión",
    <i className="bi bi-box-arrow-left"></i>,
    useRef(null),
    useRef(null),
    "out",
  ],
];

  return (<> <div className="col-2 navbarscroll d-none d-md-block">
  <div
    className=" w-100 mx-auto py-4  text-center"
    style={{ height: "20%" }}
  >
    <img
      alt="logo_alta_black"
      style={{ padding: "5% 20%", width: "80%" }}
      src={process.env.PUBLIC_URL + "/assets/img/logo_alta_black.png"}
    />
  </div>
  <div
    className=" w-100"
    style={{
      height: "auto",
    }}
  >
    {Barra.map((elementos, index) => (
      <div
        key={index}
        id={`Barralis` + index}
        ref={elementos[2]}
        style={{ fontWeight: "600" }}
        className="d-flex option-page text-color-title  py-3 "
        onClick={() =>
          selectOption(
            elementos[2],
            index,
            "d-flex option-page fw-bold  py-3 ",
            Barra,
            true,
            elementos[4]
          )
        }
      >
        <div className="my-auto mx-2 Iconresponsive">{elementos[1]} </div>
        <div className="mx-2 letraPequeña">{elementos[0]} </div>
      </div>
    ))}
  </div>
  </div>
  
    <div
      className="col-10 " style={{height:'100%'}}
    >
    <Joyride
        steps={pasos}
        run={correr}
        hideCloseButton
        disableScrolling={heightjoyride}
        showSkipButton
        continuous
        stepIndex={stepIndex}
        disableOverlayClose={true}
        disableCloseOnEsc={true}
        styles={{
          spotlight: {
            // Set your border-radius here!
            borderRadius: 20,
          },
          options: {
            primaryColor: "#CB3D82",
          },
        }}
        callback={handleJoyrideCallback}
      />
     
      <div
        className=" position-relative "
        style={{
          background: "rgba(0,0,0,.7)",
          height: "100vh",

          padding: "2% 3% 2% 2%",
        }}
      >
        <div className="d-flex col-12" style={{ gap: "2%", height: "100%" }}>
        <Categorias/>
          {stepIndexFast <4? <Paso1 trainings={trainings} indexStep={stepIndexFast} typeClasses={true}/>:stepIndexFast == 4? <Paso2 tutorial={true} infoTraining={{credits:0, name:'Zumba grupal',time:'55',calories:'500',group:true,cover_picture: process.env.PUBLIC_URL + "/img/mascarareservafinal.png",descripton:`Una de nuestras clases grupales favoritas. ¿Qué mejor que entrenar y fortalecer tu cuerpo al ritmo de la música? ganaras gran resistencia aeróbica y perderás grasa, gracias al trabajo multifuncional de todas las zonas musculares.`}}/>:stepIndexFast == 5? <Paso3 tomorrow={tomorrow} trainers={trainers}/>:stepIndexFast == 6? <Paso4  trainers={trainers} />:stepIndexFast == 7? <Paso5 mostrarClases={true} zonahorairachange={zonahorairachange && zonahorairachange.timezone} reservasAll={reservasPaso5} indexStep={stepIndexFast} nameTraining={"Zumba"} trainers={trainers} trainer={"Hugo Ortiz"}/>:stepIndexFast == 11?<Paso6 profesores={profesores} imageSuperior={process.env.PUBLIC_URL + "/img/tutorialTrainer.jpg"} infoTraining={{name:'Funcional'}} indexStep={stepIndexFast} trainers={trainers} />:stepIndexFast >7 && stepIndexFast <10? <Paso1 trainings={trainings}  typeClasses={false} indexStep={stepIndexFast} />:stepIndexFast == 10? <Paso2  infoTraining={{credits:0, name:'Funcional',time:'55',calories:'500',group:true,cover_picture: process.env.PUBLIC_URL + "/img/funcionalTest.png",descripton:`Una de nuestras clases grupales favoritas. ¿Qué mejor que entrenar y fortalecer tu cuerpo al ritmo de la música? ganaras gran resistencia aeróbica y perderás grasa, gracias al trabajo multifuncional de todas las zonas musculares.`}}/>:stepIndexFast == 12?<Paso7 tutorialDay={dateTest&&dateTest} indexStep={stepIndexFast} Trainer={10} infoTraining={{name:'Funcional', id:10}} />:stepIndexFast == 13?<Paso4  trainers={trainers} />:stepIndexFast == 14?<Paso5 mostrarClases={true} zonahorairachange={zonahorairachange && zonahorairachange.timezone} reservasAll={reservasPaso5} indexStep={stepIndexFast} nameTraining={"Zumba"} trainers={trainers} trainer={"Hugo Ortiz"}/>:null}
        </div>
      </div>
    </div></>
  );
};
export default TutorialReserva;

